const BASE = process.env.REACT_APP_API_URL || 'https://portfoliotracker-production-5eb2.up.railway.app';

async function request(path, accessToken, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      ...options.headers,
    },
    ...options,
  });
  if (!res.ok) {
    const text = await res.text();
    let msg = 'Request failed';
    try { msg = JSON.parse(text).message || msg; } catch {}
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  const text = await res.text();
  return text ? JSON.parse(text) : {};
}

export const adminApi = {
  ping:       (accessToken)     => request('/api/admin/ping',           accessToken),
  stats:      (accessToken)     => request('/api/admin/stats',          accessToken),
  users:      (accessToken)     => request('/api/admin/users',          accessToken),
  userDetail: (accessToken, id) => request(`/api/admin/users/${id}`,    accessToken),
  tiers:      (accessToken)     => request('/api/admin/tiers',          accessToken),
  setTier:    (accessToken, id, tier) =>
    request(`/api/admin/users/${id}/tier`, accessToken, {
      method: 'PUT', body: JSON.stringify({ tier }),
    }),
  setMaxPortfolios: (accessToken, id, maxPortfolios) =>
    request(`/api/admin/users/${id}/max-portfolios`, accessToken, {
      method: 'PUT', body: JSON.stringify({ maxPortfolios }),
    }),
  deleteUser: (accessToken, id) =>
    request(`/api/admin/users/${id}`, accessToken, { method: 'DELETE' }),

  // Downloads the backup ZIP and triggers a browser download.
  // Returns the filename used.
  async downloadBackup(accessToken) {
    const res = await fetch(`${BASE}/api/admin/backup`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!res.ok) {
      const text = await res.text();
      let msg = 'Backup failed';
      try { msg = JSON.parse(text).message || msg; } catch {}
      const err = new Error(msg);
      err.status = res.status;
      throw err;
    }

    // Try to read filename from Content-Disposition header
    let filename = `inverow-backup-${new Date().toISOString().replace(/[:.]/g, '-')}.zip`;
    const cd = res.headers.get('Content-Disposition');
    if (cd) {
      const match = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
      if (match) filename = decodeURIComponent(match[1]);
    }

    const blob = await res.blob();
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href     = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    return filename;
  },
};
